import script from "./ChallengeTeaser.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChallengeTeaser.vue?vue&type=script&setup=true&lang=ts"

import "./ChallengeTeaser.vue?vue&type=style&index=0&id=effb58c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-effb58c8"]])

export default __exports__